import React from 'react';
import { Grid } from '@material-ui/core'
import SelectCustom from '../../common/components/input/SelectCustom';

const dateFieldOptions = [
    { name: "Month Year", value: 'month-year' },
    { name: "Day", value: 'day' },
    { name: "Year", value: 'year' },
    { name: "Quarter Year", value: 'quarter-year' },
    { name: "Date", value: 'date' }
],
    dateFieldYearStartOptions = [
        { "name": "January", value: '1' },
        { "name": "February", value: '2' },
        { "name": "March", value: '3' },
        { "name": "April", value: '4' },
        { "name": "May", value: '5' },
        { "name": "June", value: '6' },
        { "name": "July", value: '7' },
        { "name": "August", value: '8' },
        { "name": "September", value: '9' },
        { "name": "October", value: '10' },
        { "name": "November", value: '11' },
        { "name": "December", value: '12' },
    ],
    dateFieldQuarterYearStartOptions = [
        { "name": "January", value: '1' },
        { "name": "February", value: '2' },
        { "name": "March", value: '3' },
        { "name": "April", value: '4' },
        { "name": "May", value: '5' },
        { "name": "June", value: '6' },
        { "name": "July", value: '7' },
        { "name": "August", value: '8' },
        { "name": "September", value: '9' },
        { "name": "October", value: '10' },
        { "name": "November", value: '11' },
        { "name": "December", value: '12' },
    ]

const dayFieldValues = [
    { "name": "Sunday", value: '1' },
    { "name": "Monday", value: '2' },
    { "name": "Tuesday", value: '3' },
    { "name": "Wednesday", value: '4' },
    { "name": "Thursday", value: '5' },
    { "name": "Friday", value: '6' },
    { "name": "Saturday", value: '7' },
]

export function dayFieldSorter(a, b) {
    a = a || "";
    b = b || "";

    let day1 = dayFieldValues.find(day => day.name.toLowerCase() == a.toLowerCase()) || {}
    let day2 = dayFieldValues.find(day => day.name.toLowerCase() == b.toLowerCase()) || {}

    return day1.value > day2.value ? 1 : -1;
}

export function quarterYearFieldSorter(a, b) {
    a = a || "";
    b = b || "";

    a = a.split(" ");
    b = b.split(" ");

    if (a[1] == b[1]) {
        return a[0] > b[0] ? 1 : -1;
    } else {
        return a[1] > b[1] ? 1 : -1;
    }
}

export default function DateOptions(props) {
    const groupByOptions = props.column.group_by_options || {},
        format = groupByOptions.format || {};

    return (
        <Grid
            item
            container
            direction="row"
            spacing={1}
        >
            <Grid item >
                <SelectCustom
                    className="gray_dropdown"
                    value={groupByOptions.format}
                    valueKey={'value'}
                    labelPosition="inline"
                    label="format"
                    // value={value}
                    values={dateFieldOptions}
                    onChange={(val) => {
                        props.onChange({ format: val, value: { value: 1 } })
                    }}
                    shouldForwardEvent={false}
                />
            </Grid>

            {format.value == "quarter-year" &&
                <Grid item >
                    <SelectCustom
                        className="gray_dropdown"
                        value={groupByOptions.value}
                        valueKey={'value'}
                        labelPosition="inline"
                        label="Quarter Year Starts at"
                        // value={value}
                        values={dateFieldQuarterYearStartOptions}
                        onChange={(val) => { props.onChange({ format: groupByOptions.format, value: val }) }}
                        shouldForwardEvent={false}
                    />
                </Grid>
            }

            {format.value == "year" &&
                <Grid item >
                    <SelectCustom
                        className="gray_dropdown"
                        value={groupByOptions.value}
                        valueKey={'value'}
                        labelPosition="inline"
                        label="Year Starts At"
                        // value={value}
                        values={dateFieldYearStartOptions}
                        onChange={(val) => { props.onChange({ format: groupByOptions.format, value: val }) }}
                        shouldForwardEvent={false}
                    />
                </Grid>
            }
        </Grid >
    );
}